import React from 'react';

import MaskedTextField from '../form/MaskedTextField';
import luhn from '../../shared/luhn';

const { WH_API_URL } = process.env;

function parseSIREN(siren) {
  return siren && siren.replace(/[^0-9]/g, '');
}

function isValid(siren) {
  return siren.length === 9 && luhn(siren);
}

export default function SIRENField(props) {
  return (
    <MaskedTextField
      inputProps={{ mask: '111 111 111' }}
      validators={{
        // Consider the empty value as valid, in case the field is optional.
        isValid: siren => !siren || isValid(siren),
      }}
      asyncValidators={{
        exists: (value, done) => {
          const siren = parseSIREN(value);
          // Async validators are always ran alongside sync validators, but
          // we don't need to run this one if we already know the siren is
          // invalid.
          if (!siren || !isValid(siren)) {
            done(true);
            return;
          }

          // If our validation server is down one way or another, then don't
          // stop the user from submitting the field.
          fetch(`${WH_API_URL}siren?siren=${siren}`)
            .then(res =>
              done(res.status === 200 || res.status === 500)
            )
            .catch(() => done(true));
        },
      }}
      messages={{
        isValid: 'Numéro de SIREN invalide.',
        exists: 'Ce numéro de SIREN n\'existe pas.',
      }}
      parser={parseSIREN}
      {...props}
    />
  );
}



/** WEBPACK FOOTER **
 ** ./client/act/SIRENField.js
 **/